/**
 * deviceFingerprint.ts — Stable client device identifier for license binding.
 *
 * Stored in localStorage so the device_id remains identical across application restarts.
 */

const DEVICE_ID_KEY = "sp_device_id";

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && existing.trim().length > 0) {
      return existing.trim();
    }
  } catch {
    // localStorage might be unavailable in restricted environments
  }

  // Generate a standard RFC4122 v4 UUID
  const newId = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `sp-dev-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;

  try {
    localStorage.setItem(DEVICE_ID_KEY, newId);
  } catch {
    // Best-effort
  }

  return newId;
}
